import { DEMO_PRESETS } from "@/data/situations";
import { Zap } from "lucide-react";

export function DemoMode({ onPreset }) {
  return (
    <section className="relative py-16 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-4">
          <Zap size={14} className="text-[color:var(--lg-lime)]" />
          <span className="font-mono-tac text-[10px] tracking-[0.28em] text-[color:var(--lg-lime)]">DEMO MODE</span>
          <span className="h-px w-14 bg-[color:var(--lg-line-strong)]" />
        </div>
        <h2 className="font-display text-2xl sm:text-4xl font-extrabold uppercase tracking-tight max-w-3xl">
          Tap a preset. See the full flow in <span className="text-cyan-accent">seconds</span>.
        </h2>
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {DEMO_PRESETS.map((p) => (
            <button
              key={p.id}
              onClick={() => onPreset(p)}
              className="glass rounded-md p-4 text-left hover:border-[color:var(--lg-lime)]/50 transition"
              data-testid={`demo-preset-${p.id}`}
            >
              <div className="font-mono-tac text-[10px] tracking-[0.28em] text-[color:var(--lg-cyan)]">SCENARIO</div>
              <div className="mt-2 text-base md:text-lg">{p.text}</div>
              <div className="mt-3 font-mono-tac text-[10px] tracking-[0.28em] text-[color:var(--lg-lime)]">RUN →</div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
